import { SEARCH_RECOMMENDED_CATEGORY_GAMES_LIST_ID } from '../../../constants';

export const getGamesListId = (debouncedQuery, filter, recommendedCategory) => {
  const { providers, categories } = filter;
  if (debouncedQuery || providers.length || categories.length) {
    return `search-games-list-${debouncedQuery.replace(
      / /g,
      '-'
    )}_${providers.join('-')}_${categories.join('-')}`;
  }
  if (recommendedCategory) {
    return SEARCH_RECOMMENDED_CATEGORY_GAMES_LIST_ID;
  }
  return '';
};
